module.exports = __webpack_public_path__ + "static/media/(LH)_MG_5766_-_bijuterias.abaf3959.jpg";